module.exports = __webpack_public_path__ + "img/we_4.cf5ae4d8.svg";